import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

const client = createClient({
  projectId: "ztwoq7rz", 
  dataset: "production", 
  useCdn: true, 
  apiVersion: "2025-02-10", 
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);

export default client;
